import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-git2-icon',
  templateUrl: './code-git2.component.html'
})
export class CodeGit2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
